import React, { useState } from "react";
import SearchBox from "./SearchBox.jsx";
import Link from "react-router-dom/Link.js";
import Logo from "../../../asset/img/onpr_logo_2.png";
import headerImage from "../../../asset/img/Header.jpg";
import BackGroundImage from "../../../components/admin/web/BackGroundImage.jsx";

const Header = ({ onSearch, searchResults, isSearching }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [language, setLanguage] = useState(
    localStorage.getItem("language") || "fr"
  );

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const handleLanguageChange = (e) => {
    setLanguage(e.target.value);
    localStorage.setItem("language", e.target.value);
    window.location.href =
      window.location.origin + (e.target.value === "en" ? "/" : "/");
  };

  return (
    <>
      <div className="top-banner">
        <img src={headerImage} alt="ONPR" />
      </div>

      <div className="contact-bar">
        <div className="contact-info">
          <div className="contact-details">
            <div className="contact-item">
              <i className="pi pi-envelope"></i>
              <span>info@onpr.bi</span>
            </div>
            <div className="contact-item">
              <i className="pi pi-phone"></i>
              <span>+257 22 27 62 29</span>
            </div>
            <div className="contact-item">
              <i className="pi pi-map-marker"></i>
              <span>Quartier ROHERO I : Chaussée du P.L.RWAGASORE, N°187</span>
            </div>
          </div>

          <div
            className="social-and-language"
            style={{ display: "flex", alignItems: "center", gap: "1rem" }}
          >
            <div
              className="social-links"
              style={{ display: "flex", gap: "0.5rem", marginBottom: "15px" }}
            >
              <a
                target="_blank"
                href="https://www.facebook.com/onpr.bi"
                className="facebook"
              >
                <i className="pi pi-facebook"></i>
              </a>
              <a
                target="_blank"
                href="https://x.com/Onpr2018"
                className="twitter"
              >
                <i className="pi pi-twitter"></i>
              </a>
              <a
                target="_blank"
                href="https://www.youtube.com/@onprburundi8558"
                className="youtube"
              >
                <i className="pi pi-youtube"></i>
              </a>
              <a
                target="_blank"
                href="https://wa.me/25722276229"
                className="Whatsapp"
              >
                <i className="pi pi-whatsapp"></i>
              </a>
            </div>

            <div className="language-selector">
              <select value={language} onChange={handleLanguageChange}>
                <option value="fr"> Français</option>
                <option value="en">English</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <header>
        <div className="header-content">
          <div className="logo-section">
            <div className="logo">
              <img src={Logo} alt="Logo" />
            </div>
            <div className="site-title">ONPR</div>
          </div>

          <div style={{ backgroundColor: "red", borderRadius: "10px" }}>
            <marquee
              className="marquee-text"
              behavior="scroll"
              direction="left"
              scrollamount="6"
              style={{
                fontWeight: "bold",
                fontSize: "1.6rem",
                color: "white",
                // color: "#2020ffc6",
              }}
            >
              {/* Une main qui cotise,Une main qui s'assure */}
              UNE MAIN QUI COTISE ={" "}
              <span style={{ color: "white" }}>UNE MAIN QUI S'ASSURE!</span>
            </marquee>
          </div>

          <button className="mobile-menu-btn" onClick={toggleDrawer}>
            <i className="pi pi-bars"></i>
          </button>

          <SearchBox
            onSearch={onSearch}
            searchResults={searchResults}
            isSearching={isSearching}
          />
        </div>
      </header>

      <div
        className={`drawer-overlay ${isDrawerOpen ? "active" : ""}`}
        onClick={toggleDrawer}
      ></div>

      <div className={`mobile-drawer ${isDrawerOpen ? "active" : ""}`}>
        <div className="drawer-header">
          <div>
            <strong>ONPR</strong>
            <div style={{ fontSize: "0.8rem", opacity: 0.9 }}>Burundi</div>
          </div>
          <button className="drawer-close" onClick={toggleDrawer}>
            &times;
          </button>
        </div>

        <ul className="drawer-menu">
          <li>
            <Link to="/" onClick={toggleDrawer}>
              <i className="pi pi-home"></i> Accueil
            </Link>
          </li>
          <li>
            <Link to="/informations" onClick={toggleDrawer}>
              <i className="pi pi-info-circle"></i> Information
            </Link>
          </li>
          <li>
            <Link to="/annonce-communique" onClick={toggleDrawer}>
              <i className="pi pi-file"></i> Annonces et Communiqués
            </Link>
          </li>
          <li>
            <Link to="/galerie-photos" onClick={toggleDrawer}>
              <i className="pi pi-image"></i> Galerie Photos
            </Link>
          </li>
          <li>
            <Link to="/calendrier-evenements" onClick={toggleDrawer}>
              <i className="pi pi-calendar"></i> Calendrier des Événements
            </Link>
          </li>
          <li>
            <Link to="/contacts" onClick={toggleDrawer}>
              <i className="pi pi-chart-line"></i> Contacts
            </Link>
          </li>
          <li>
            <Link to="/online-service" onClick={toggleDrawer}>
              <i className="pi pi-cog"></i> Services en ligne
            </Link>
          </li>
          <li>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.onpr.bi:2096/"
            >
              WebMail
            </a>
          </li>
          <li>
            <Link to="/se-connecter" onClick={toggleDrawer}>
              <i className="pi pi-book"></i> Se Connecter
            </Link>
          </li>
        </ul>
      </div>
    </>
  );
};

export default Header;
